import { connect } from "react-redux";
import CrearActualizar from "./ClientesCrear";
import { actions } from "../../../../redux/modules/cliente/cliente";

const ms2p = (state) => {
    return {
        ...state.cliente,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CrearActualizar);
